import {Component, ElementRef, Input, OnChanges, ViewChild, ViewEncapsulation} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AppIconsList, BlockElementType, IconsFolder} from 'app/entities/enums';
import {BlockElementIcon} from '../../../entities/blockElements/blockElementIcon';


@Component({
  selector: 'app-icon',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
  encapsulation: ViewEncapsulation.None
})

/**
 * Configurable params:
 * - iconName             - название файла иконки
 * - outputSvg            - (optional) отображать как svg (иначе как img)
 * - folder               - (optional) использовать альтернативную папку с иконками вместо icons (иконки по новому стандарту)
 * - customStrokeColor    - (optional) если outputSvg: true, то динамически задаст кастомный цвет параметру stroke внутри svg
 * - customFillColor      - (optional) если outputSvg: true, то динамически задаст кастомный цвет параметру fill внутри svg
 *
 *  Usage:
 * ```
 *    <app-icon
 *      [iconName]="route.data.menuIcon"
 *      [folder]="'new-icons'"
 *      [outputSvg]="true"
 *      [customStrokeColor]="customColor(route)"
 *    ></app-icon>
 * ```
 */
export class IconComponent implements OnChanges {
  @ViewChild('svgContainer', {static: false}) svgContainer: ElementRef;

  // @todo add all icons as type, from button
  @Input() public iconName?: AppIconsList | string;
  @Input() public outputSvg?: boolean = false;
  @Input() public folder?: IconsFolder = 'icons';
  @Input() public customStrokeColor?: string = null;
  @Input() public customFillColor?: string = null;

  // public svgIcon: any;

  constructor(
    private httpClient: HttpClient,
    // private sanitizer: DomSanitizer,
  ) {
  }

  public ngOnChanges(): void {
    if (!this.iconName) {
      // this.svgIcon = '';
      return;
    }

    if (this.outputSvg) {
      this.httpClient
        .get(this.getIconPath(), {responseType: 'text'})
        .subscribe(value => {
          // this.svgIcon = this.sanitizer.bypassSecurityTrustHtml(value);
          this.svgContainer.nativeElement.innerHTML = value;

          // console.log('children', this.iconSvg?.nativeElement.children);
          this.svgContainer?.nativeElement.querySelectorAll('path').forEach((item) => {
            if (this.customStrokeColor) {
              item.setAttribute('style', 'stroke: ' + this.customStrokeColor);
            }
            if (this.customFillColor) {
              item.setAttribute('style', 'fill: ' + this.customFillColor);
            }
          });
        });
    }
  }

  getIconPath() {
    return `assets/${this.folder}/${this.iconName}.svg`;
  }
}
